import React from "react";

export default function AboutNFTs() {
  return (
    <>
      <div className="fq-faq-area fq-faq-bdr pt-100 pb-100">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <h1 className="text-color-yellow bold-text">
                About Kryptogram NFTs
              </h1>
              <div className="fq-faq-wrapper">
                <div className="tp-service-2-accordion-box">
                  <div className="accordion" id="accordionExample">
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          What are Kryptogram NFTs?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Kryptogram NFTs are blockchain-based digital assets
                            that grant exclusive real-world ownership benefits
                            and event access. These NFTs offer:
                          </p>
                          <div className="tp-about-2-content">
                            <span>Land Ownership</span>
                            <p className="mb-30">
                              Holders who purchase 5 NFTs in a single
                              transaction receive 100 sq. ft. of land on
                              Kryptogram Island (USA).
                            </p>
                            <span>Festival Access</span>
                            <p className="mb-30">
                              Each Kryptogram NFT serves as an entry ticket to
                              the Tribe O Crypto Festival in Abu Dhabi.
                            </p>
                            <span>Future Blockchain Rewards</span>
                            <p className="mb-30">
                              NFT holders will gain access to staking, yield
                              farming, and additional blockchain integrations in
                              future updates.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          What is the difference between the 55,000 Kryptogram
                          NFTs and the 200 Exclusive Crypto Whale NFTs?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            There are two distinct categories of Kryptogram NFTs
                          </p>
                          <div className="tp-about-2-content">
                            <span>55,000 Elite Kryptogram NFTs</span>
                            <p className="mb-30">
                              These NFTs grant access to the Tribe O Crypto
                              Festival and allow holders to accumulate land on
                              Kryptogram Island.
                            </p>
                            <span>200 Super Elite NFTs</span>
                            <p className="mb-30">
                              These are reserved for elite crypto investors and
                              VIP attendees, offering luxury festival
                              experiences, including helicopter transfers,
                              ultra-luxury lounges, and premium concierge
                              services.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          How many Kryptogram NFTs do I need to own land?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            To own 100 sq. ft. of land on Kryptogram Island, you
                            must purchase 5 Kryptogram NFTs in a single
                            transaction.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefour"
                          aria-expanded="false"
                          aria-controls="collapsefour"
                        >
                          Can I sell or transfer my Kryptogram NFT?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapsefour"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Yes, Kryptogram NFTs are fully tradable and can be
                            sold, transferred, or exchanged on supported NFT
                            marketplaces.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
